import { render, staticRenderFns } from "./MetadataPanel.vue?vue&type=template&id=65b442c3&scoped=true"
import script from "./MetadataPanel.vue?vue&type=script&lang=js"
export * from "./MetadataPanel.vue?vue&type=script&lang=js"
import style0 from "./MetadataPanel.vue?vue&type=style&index=0&id=65b442c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b442c3",
  null
  
)

export default component.exports